/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lg_Guest_OkInputs */

const en_lg_guest_ok = /** @type {(inputs: Lg_Guest_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guests see only the approved area and, if selected by the host, its associated call. A visit lasts at most two hours and can end earlier.`)
};

const id_lg_guest_ok = /** @type {(inputs: Lg_Guest_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamu hanya melihat area yang disetujui dan, jika dipilih host, panggilan yang terkait. Kunjungan berlangsung paling lama dua jam dan dapat diakhiri lebih cepat.`)
};

/**
* | output |
* | --- |
* | "Guests see only the approved area and, if selected by the host, its associated call. A visit lasts at most two hours and can end earlier." |
*
* @param {Lg_Guest_OkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const lg_guest_ok = /** @type {((inputs?: Lg_Guest_OkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lg_Guest_OkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_lg_guest_ok(inputs)
	return en_lg_guest_ok(inputs)
});